import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

/**
 * 存货单列表
 * @param {Object} params
 */
export const getInventoryList = params => axios({
  url: `${commonPath}stock/inventory_list`,
  method: 'post',
  data: params
})

/**
 * 存货单详情
 * @param {String} id
 */
export const getInventoryInfo = id => axios({
  url: `${commonPath}stock/inventory/${id}`,
  method: 'get'
})

/**
 * 存货单联系人
 * @param {Object} params
 */
export const getInventoryContacts = params => axios({
  url: `${commonPath}inventory/contacts`,
  method: 'post',
  data: params
})

/**
 * 存货项列表
 * @param {Object} params
 */
export const getStockList = params => axios({
  url: `${commonPath}stock/stock_list`,
  method: 'post',
  data: params
})

// 存货项-导出
export const exportStockLine = params => axios({
  url: `${commonPath}stock/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

/**
 * 存货项详情
 * @param {String} id
 */
export const getStockInfo = id => axios({
  url: `${commonPath}stock/stock/${id}`,
  method: 'get'
})

/**
 * 分拣明细
 * @param {Object} params
 */
export const getPickingDetailList = params => axios({
  url: `${commonPath}stock/picking_line/list`,
  method: 'post',
  data: params
})

/**
 * 存货项联系人
 * @param {Object} params
 */
export const getStockContacts = params => axios({
  url: `${commonPath}stock/contacts`,
  method: 'post',
  data: params
})
